import { inject, Injectable } from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { Observable } from 'rxjs';
import { CmsContentMapperService } from './cms-content-mapper.service';
import { map } from 'rxjs/operators';
import { ContentUpdaterService } from './content-updater/content-updater.service';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _contentUpdater = inject(ContentUpdaterService);

  /**
   * Get promotions list from CMS and prepare for using in frontend
   *
   * @param params
   * @param extraParams
   */
  list(params: object = {}, extraParams = {}): Observable<any> {
    return this._contentUpdater.registerContent('promo/list', params, () =>
      this._api.promotionList(params).pipe(
        map(response =>
          this._mapper.mapCmsData(response.data, {
            id: 'id',
            slug: 'slug',
            publishAt: 'publishAt',
            cmsItemName: 'name',
            unpublishAt: 'unpublishAt.date',
            ...extraParams,
          }),
        ),
      ),
    );
  }

  /**
   * Get promotions item from CMS and prepare for using in frontend
   *
   * @param params
   */
  item(params: object = {}): Observable<any> {
    return this._contentUpdater.registerContent('promo/item', params, () =>
      this._api.promotionItem(params).pipe(
        map(response => {
          if (response.statusCode === 200) {
            return this._mapper.mapCmsData(response.data, {
              slug: 'slug',
              publishAt: 'publishAt.date',
              unpublishAt: 'unpublishAt.date',
              name: 'name',
            });
          } else {
            return [
              {
                statusCode: response.statusCode,
              },
            ];
          }
        }),
      ),
    );
  }
}
